import { render } from "./ListeTypeMedia.vue?vue&type=template&id=afb0af44&ts=true"
import script from "./ListeTypeMedia.vue?vue&type=script&lang=ts"
export * from "./ListeTypeMedia.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__